/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StudentPersonalDataDTO
 */
export interface StudentPersonalDataDTO {
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	birthPlace?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	city?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	county?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	streetName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	streetNumber?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	building?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	floor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	apartment?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	identitySeries?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	identityNumber?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	identityIssuer?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof StudentPersonalDataDTO
	 */
	identityDate?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	cnp?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	passport?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof StudentPersonalDataDTO
	 */
	residencePermit?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof StudentPersonalDataDTO
	 */
	birthdate?: Date;
}

export function StudentPersonalDataDTOFromJSON(
	json: any
): StudentPersonalDataDTO {
	return StudentPersonalDataDTOFromJSONTyped(json, false);
}

export function StudentPersonalDataDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): StudentPersonalDataDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		birthPlace: !exists(json, "birthPlace") ? undefined : json["birthPlace"],
		city: !exists(json, "city") ? undefined : json["city"],
		county: !exists(json, "county") ? undefined : json["county"],
		streetName: !exists(json, "streetName") ? undefined : json["streetName"],
		streetNumber: !exists(json, "streetNumber")
			? undefined
			: json["streetNumber"],
		building: !exists(json, "building") ? undefined : json["building"],
		floor: !exists(json, "floor") ? undefined : json["floor"],
		apartment: !exists(json, "apartment") ? undefined : json["apartment"],
		identitySeries: !exists(json, "identitySeries")
			? undefined
			: json["identitySeries"],
		identityNumber: !exists(json, "identityNumber")
			? undefined
			: json["identityNumber"],
		identityIssuer: !exists(json, "identityIssuer")
			? undefined
			: json["identityIssuer"],
		identityDate: !exists(json, "identityDate")
			? undefined
			: new Date(json["identityDate"]),
		cnp: !exists(json, "cnp") ? undefined : json["cnp"],
		passport: !exists(json, "passport") ? undefined : json["passport"],
		residencePermit: !exists(json, "residencePermit")
			? undefined
			: json["residencePermit"],
		birthdate: !exists(json, "birthdate")
			? undefined
			: new Date(json["birthdate"]),
	};
}

export function StudentPersonalDataDTOToJSON(
	value?: StudentPersonalDataDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		birthPlace: value.birthPlace,
		city: value.city,
		county: value.county,
		streetName: value.streetName,
		streetNumber: value.streetNumber,
		building: value.building,
		floor: value.floor,
		apartment: value.apartment,
		identitySeries: value.identitySeries,
		identityNumber: value.identityNumber,
		identityIssuer: value.identityIssuer,
		identityDate:
			value.identityDate === undefined
				? undefined
				: value.identityDate.toISOString(),
		cnp: value.cnp,
		passport: value.passport,
		residencePermit: value.residencePermit,
		birthdate:
			value.birthdate === undefined ? undefined : value.birthdate.toISOString(),
	};
}
